export default "__VITE_ASSET__b661ec21__"